<ng-template #progressTemplate let-config="config">
  <div class="relative">
    <div class="my-2 h-1.5 rounded-full bg-aux-gray-dark"></div>
    <div
      class="absolute inset-0 h-1.5 rounded-full"
      [ngClass]="{
        'bg-aux-green': config.progressColor === 'green',
        'bg-aux-blue': config.progressColor === 'blue',
      }"
      [style.width]="config.value + '%'"
    ></div>
  </div>
</ng-template>

<div class="mb-16 flex items-center justify-between">
  <h1 class="flex h-11 items-center text-2xl font-bold text-aux-gray-darkest">Risk Analytics</h1>
</div>

<div class="mb-24 flex flex-col flex-wrap" style="height: 900px; width: calc(100% - 2.5rem)">
  <aux-risk-card class="mb-5 mr-5 w-1/3" [alerts]="timelineAlerts">
    <div class="mb-4 text-xl font-bold text-aux-black">Timelines / Milestones</div>

    <ng-template #progress let-config="config">
      <div>
        <div class="text-sm font-medium text-aux-black">
          {{ config.header }}
        </div>

        <ng-container
          [ngTemplateOutlet]="progressTemplate"
          [ngTemplateOutletContext]="{
            config: config,
          }"
        />

        <!-- <progressbar-->
        <!--   [value]="config.value"-->
        <!--   [max]="100"-->
        <!--   [ngClass]="{-->
        <!--     green: config.progressColor === 'green',-->
        <!--     blue: config.progressColor === 'blue'-->
        <!--   }"-->
        <!--   class="h-1.5 my-2 bg-aux-gray-dark"-->
        <!-- ></progressbar>-->

        <div class="flex items-center justify-between">
          <div class="text-xs text-aux-black">{{ config.leftLabel }}</div>
          <div class="text-xs text-aux-black">{{ config.rightLabel }}</div>
        </div>
      </div>
    </ng-template>

    <div class="space-y-4">
      @for (timeline of timelineData; track timeline) {
        <ng-container
          [ngTemplateOutlet]="progress"
          [ngTemplateOutletContext]="{
            config: timeline,
          }"
        />
      }
    </div>
  </aux-risk-card>

  <aux-risk-card class="mb-5 mr-5 w-1/3" [alerts]="paceOfSpendAlerts">
    <div class="mb-4 text-xl font-bold text-aux-black">Pace of Spend</div>

    <div class="mb-8 flex justify-between">
      <div class="text-xs text-aux-black">
        <div>Current Spend</div>
        <div class="mt-2 text-sm font-bold text-aux-black">$789,409</div>
      </div>
      <div class="text-xs text-aux-black">
        <div>Total Budget</div>
        <div class="mt-2 text-sm font-bold text-aux-black">$789,409</div>
      </div>
      <div class="text-xs text-aux-black">
        <div>Amount Remaining</div>
        <div class="mt-2 text-sm font-bold text-aux-black">$1,910,591 / 71%</div>
      </div>
    </div>

    <div class="relative">
      <div class="my-2 h-6 rounded-l-none rounded-r bg-aux-gray-dark"></div>
      <div
        class="absolute inset-0 h-6 rounded-l-none rounded-r bg-aux-blue"
        style="width: 30%"
      ></div>
    </div>

    <hr class="my-2" />
    <div class="flex items-center justify-between">
      <div class="text-xs text-aux-black">$0</div>
      <div class="text-xs text-aux-black">$500k</div>
      <div class="text-xs text-aux-black">$1m</div>
      <div class="text-xs text-aux-black">$1.5m</div>
      <div class="text-xs text-aux-black">$2m</div>
      <div class="text-xs text-aux-black">$2.5m</div>
      <div class="text-xs text-aux-black">$3m</div>
    </div>
  </aux-risk-card>

  <aux-risk-card class="mb-5 mr-5 w-1/3" [alerts]="patientAlerts">
    <div class="mb-4 text-xl font-bold text-aux-black">Patient Enrollment</div>

    <div class="mb-2 text-xs font-medium text-aux-black"># of Patients / Avg Patient Cost</div>
  </aux-risk-card>

  <aux-risk-card class="mb-5 mr-5 w-1/3" [alerts]="fpAlerts">
    <div class="mb-4 text-xl font-bold text-aux-black">FP&A Health</div>
  </aux-risk-card>

  <aux-risk-card class="mb-5 mr-5 w-1/3" [alerts]="siteAlerts">
    <div class="mb-4 text-xl font-bold text-aux-black">Site Health</div>

    <div class="mb-4 text-xs font-medium text-aux-black">
      Average Site Health Score:
      <span class="font-bold">50</span>
    </div>

    <table class="w-full">
      <thead>
        <th></th>
        <th class="text-center text-xs font-normal text-aux-black">Enrolled Patients</th>
        <th class="text-center text-xs font-normal text-aux-black">Health Score</th>
      </thead>
      <tbody>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Columbia Presbyterian</td>
          <td class="text-center text-sm"><strong>61</strong></td>
          <td class="text-center text-sm"><strong>58</strong></td>
        </tr>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Mt. Sinai West</td>
          <td class="text-center text-sm"><strong>24</strong></td>
          <td class="text-center text-sm"><strong>47</strong></td>
        </tr>
        <tr class="border-b border-aux-gray-light">
          <td class="py-2 text-sm font-medium text-aux-black">Mass General Hospital</td>
          <td class="text-center text-sm"><strong>12</strong></td>
          <td class="text-center text-sm"><strong>34</strong></td>
        </tr>
      </tbody>
    </table>

    <a href="#" class="mt-2 block text-sm font-medium text-aux-blue underline">See all sites</a>
  </aux-risk-card>
</div>
